import { UserState } from '@/models/user/state.interface';
import { store } from '@conversa/reflex';

export const userInitialState: UserState = {
  accessToken: null,
  dialogTimeoutId: -1,
};

export const userStore = store(userInitialState);
